import {clsx, type ClassValue} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}


export function formatDate(date: Date|undefined): string {
    if (!date) {
        return ""; 
    }
    const parsedDate = date instanceof Date ? date : new Date(date); // Convertir si besoin
    if (isNaN(parsedDate.getTime())) {
      return ""; // Vérifie si la date est invalide et retourne une chaîne vide
    }
    return new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' }).format(parsedDate);
  }

export function isHttpSuccess(code : number) {
    if (code>=200 && code<=300) return true;
    return false;
}

export function getHttpErrorString(code: number): string {
    const errorMessages: Record<number, string> = {
      400: "Bad Request - La requête est mal formulée ou invalide.",
      401: "Unauthorized - Authentification requise ou invalide.",
      403: "Forbidden - Accès refusé à la ressource.",
      404: "Not Found - Ressource introuvable.",
      405: "Method Not Allowed - Méthode HTTP non autorisée.",
      408: "Request Timeout - Temps d’attente dépassé.",
      409: "Conflict - Conflit avec l’état actuel de la ressource.",
      410: "Gone - La ressource n’existe plus.",
      413: "Payload Too Large - Taille de requête trop grande.",
      415: "Unsupported Media Type - Type de contenu non supporté.",
      429: "Too Many Requests - Trop de requêtes envoyées en peu de temps.",
      500: "Internal Server Error - Erreur serveur.",
      501: "Not Implemented - Fonctionnalité non supportée.",
      502: "Bad Gateway - Réponse invalide du serveur amont.",
      503: "Service Unavailable - Serveur temporairement indisponible.",
      504: "Gateway Timeout - Temps d’attente expiré côté proxy.",
    };
  
    return errorMessages[code] || `Unknown Error - Code ${code}`;
  }
  

